

// Inicializa
console.log('🌐 Inicializando i18n con Svelte...');
